<app-interests-field
  [form]="form()" 
  formControlName="interestIdList"
/>